function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServicerequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.314 8.279A6.743 6.743 0 0 0 4.931.229a.469.469 0 0 0-.205.783L7.715 4l-.778 2.9-2.9.778-2.992-2.985a.469.469 0 0 0-.783.207 6.747 6.747 0 0 0 8.05 8.383l6.148 6.148a1.88 1.88 0 0 0 2.656 0l2.346-2.346a1.88 1.88 0 0 0 0-2.656zM18.8 16.42l-2.346 2.346a.941.941 0 0 1-1.33 0l-6.338-6.337a.469.469 0 0 0-.458-.12A5.805 5.805 0 0 1 1 5.972l2.562 2.564a.468.468 0 0 0 .453.121l3.426-.918a.469.469 0 0 0 .331-.331l.918-3.426a.469.469 0 0 0-.121-.453L6 .965a5.805 5.805 0 0 1 6.337 7.33.469.469 0 0 0 .12.458L18.8 15.09a.941.941 0 0 1 0 1.33z",
    transform: "translate(1.988 2.021)",
    style: {
      fill: "#6b7a8a",
      stroke: "#6c7b8b",
      strokeWidth: ".5px"
    },
    "data-name": "service request"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicerequest);
export default __webpack_public_path__ + "static/media/servicerequest.1d6cc10a1a5f182fd85ae3c9c9d3ed81.svg";
export { ForwardRef as ReactComponent };